import * as Yup from 'yup'

import { EMPTY_STRING, NOTIFICATION_TYPE } from '../../../constants/common'
import i18n from '../../../i18n'
import { getItemsIds } from '../../../utils/common'
import { getChatProfilePathname } from '../../../utils/link'
import {
  ATTACH_ACTION_SELECT_ACTION_FILE,
  ATTACH_ACTION_SELECT_FILE_FROM_STORAGE,
} from '../../AttachActionSelect'

import {
  CHAT_FORM_FIELD_NAME_FILES,
  CHAT_FORM_FIELD_NAME_LABELS,
  CHAT_FORM_FIELD_NAME_MESSAGE,
  CHAT_FORM_FIELD_NAME_PARTICIPANTS,
  CHAT_FORM_FIELD_NAME_STORAGE_FILES,
  CHAT_FORM_FIELD_NAME_TITLE,
  CHAT_FORM_TITLE_FIELD_MAX_LENGTH,
} from './ChatForm.constants'

export function getChatFormValidationSchema() {
  return Yup.object({
    [CHAT_FORM_FIELD_NAME_MESSAGE]: Yup.string().required(true),
    [CHAT_FORM_FIELD_NAME_PARTICIPANTS]: Yup.array()
      .of(Yup.object())
      .min(1, true),
    [CHAT_FORM_FIELD_NAME_TITLE]: Yup.string().max(
      CHAT_FORM_TITLE_FIELD_MAX_LENGTH,
      i18n.t('Error.MaxLengthKey', {
        limit: CHAT_FORM_TITLE_FIELD_MAX_LENGTH,
      })
    ),
  })
}

export function getChatFormCreationPayload({ values }) {
  const payload = {
    [CHAT_FORM_FIELD_NAME_LABELS]: getItemsIds(
      values[CHAT_FORM_FIELD_NAME_LABELS],
      'value'
    ),
    [CHAT_FORM_FIELD_NAME_MESSAGE]: values[CHAT_FORM_FIELD_NAME_MESSAGE],
    [CHAT_FORM_FIELD_NAME_PARTICIPANTS]: getItemsIds(
      values[CHAT_FORM_FIELD_NAME_PARTICIPANTS],
      'value'
    ),
    [CHAT_FORM_FIELD_NAME_TITLE]: values[CHAT_FORM_FIELD_NAME_TITLE],
  }

  const files = [
    ...values[CHAT_FORM_FIELD_NAME_FILES],
    ...values[CHAT_FORM_FIELD_NAME_STORAGE_FILES],
  ]

  if (files.length > 0) {
    payload[CHAT_FORM_FIELD_NAME_FILES] = getItemsIds(files)
  }

  return payload
}

export function getChatFormAttachActions({ t }) {
  return [
    {
      label: t('Chat.AttachFileActionOptionKey'),
      value: ATTACH_ACTION_SELECT_ACTION_FILE,
    },
    {
      label: t('Chat.AttachFileFromStorageActionOptionKey'),
      value: ATTACH_ACTION_SELECT_FILE_FROM_STORAGE,
    },
  ]
}

export function getChatFormSuccessNotification({
  availableSections,
  title,
  uuid,
}) {
  return {
    linkProps: {
      reloadDocument: true,
      title: i18n.t('Notification.ChatCreatedViewChatLinkKey'),
      to: getChatProfilePathname({ availableSections, uuid }),
    },
    text: i18n.t('Notification.ChatCreatedTextKey', {
      title: title || EMPTY_STRING,
    }),
    title: i18n.t('Notification.ChatCreatedTitleKey'),
    type: NOTIFICATION_TYPE.success,
  }
}

export function getChatFormErrorNotification() {
  return {
    text: i18n.t('Notification.ChatCreationErrorTextKey'),
    title: i18n.t('Notification.ChatCreationErrorTitleKey'),
  }
}
